import React, { useMemo, useState } from 'react';

import cn from 'classnames';

import { InventoryLogItem } from '@entities/equipmentInventory';
import { DateHelpers } from '@shared/helpers';
import { Lightbox, UiText } from '@shared/ui';

import cls from './HistoryLogItem.module.css';

interface HistoryLogItemProps {
    log: InventoryLogItem;
    index: number;
}

export const HistoryLogItem = ({ log, index }: HistoryLogItemProps) => {
    const [currentFileId, setCurrentFileId] = useState<number | null>(null);
    const files = useMemo(
        () =>
            (log.photos ?? []).map((photo, photoIndex) => ({
                id: photoIndex + 1,
                fileSrc: photo.originalUrl,
                fileName: `inventory-log-photo-${photoIndex + 1}`,
                mimeType: 'image/jpeg',
            })),
        [log.photos]
    );

    return (
        <li className={cls.actionItem} data-id={`history-log-${index}`}>
            <div className={cls.user}>
                {log.user?.avatarUrl ? (
                    <img
                        src={log.user.avatarUrl}
                        className={cls.userPhoto}
                        alt={log.user.name ?? 'user'}
                        title={[log.user.name, log.user.email].filter(Boolean).join('\n')}
                    />
                ) : (
                    <div className={cn(cls.userPhoto, cls.deleteUserPhoto)} />
                )}
                <UiText variant="subPlain">
                    {DateHelpers.dateFormatter({
                        date: log.datetime,
                        format: 'DD.MM.YYYY, HH:mm',
                    })}
                </UiText>
            </div>
            <div className={cls.actionInfoBlock}>
                <div className={cls.actionDescript}>
                    <UiText variant="subPlain">{log.text}</UiText>

                    {Boolean(log.photos?.length) && (
                        <div className={cls.actionPhotoWrapper}>
                            {log.photos?.map((photo, photoIndex) => (
                                <button
                                    key={photo.originalUrl}
                                    type="button"
                                    className={cls.actionPhotoButton}
                                    onClick={() => setCurrentFileId(photoIndex + 1)}
                                >
                                    <img
                                        src={photo.thumbnailUrl || photo.originalUrl}
                                        className={cls.actionPhoto}
                                        alt="inventory-log-photo"
                                    />
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {currentFileId !== null && (
                <Lightbox
                    files={files}
                    currentFileId={currentFileId}
                    onClose={() => setCurrentFileId(null)}
                />
            )}
        </li>
    );
};
